import { http, uploadFile } from '@/utils/axios'
import axios from 'axios'

/**
 * @msg: 查看课件库
 */
export function viewCourseWare(id) {
  return http({
    url: http.baseUrl('courseWare/viewCourseWare'),
    method: 'get',
    params: http.params({
      id
    })
  })
}

// 课件api
/**
 * @msg: 新增课件类别
 */
export function addType() {
  return http({
    url: http.baseUrl('zkolVideoData/getList'),
    method: 'POST',
    // params: http.params({
    //   id
    // })
  })
}

/**
 * @msg: 查询审核
 */
export function checkVerify(data) {
  return http({
    url: http.baseUrl('zkolVideoData/getList'),
    method: 'POST',
    params: http.params(data)
  })
}

/**
 * @msg: 获取课件类别列表(可以不设置参数 默认获取所有)
 */
export function getList({ page = '1', pageSize = '' }) {
  return http({
    url: http.baseUrl('zkolCourseWareType/getList'),
    method: 'POST',
    params: http.params({
      page,
      pageSize
    })
  })
}


/**
 * @msg: 获取课件列表界面
 */
export function getList2({ page = '', pageSize = '', courseWareId = '', userType = '', institutionId = '', uid = '', orderBy = "" }) {
  return http({
    url: http.baseUrl('zkolVideoData/getList'),
    method: 'POST',
    params: http.params({
      // courseWareType
      page,
      pageSize,
      courseWareId,
      userType,
      institutionId,
      uid,
      orderBy
    })
  })
}
/**
 * @msg: 获取指定课件列表界面
 */
export function getList3({ page = '', pageSize = '', courseWareId = '', courseWareType = '', userType = '', institutionId = '', uid = '' }) {
  return http({
    url: http.baseUrl('zkolVideoData/getList'),
    method: 'POST',
    params: http.params({
      courseWareType,
      page,
      pageSize,
      courseWareId,
      userType,
      institutionId,
      uid
    })
  })
}

/**
 * @msg: 搜索课件列表界面
 */
export function getList4(page, pageSize, videoType, content, courseWareId, userType, institutionId, uid, orderBy) {
  return http({
    url: http.baseUrl('zkolVideoData/getList'),
    method: 'POST',
    params: http.params({
      page,
      pageSize,
      videoType,
      content,
      courseWareId,
      userType,
      institutionId,
      uid,
      orderBy
    })
  })
}

/**
 * @msg: 新增或者修改课件类别
 */
export function saveOrUpdate({ typeName = '', remark = '', createId = '', institutionId = '' }) {
  return http({
    url: http.baseUrl('zkolCourseWareType/saveOrUpdate'),
    method: 'POST',
    params: http.params({
      typeName,
      remark,
      createId,
      institutionId,
    })
  })
}

/**
 * @msg: 获取机构列表
 */
export function getinstitutionList() {
  return http({
    url: http.baseUrl('elSchool/getList'),
    method: 'POST',
    params: http.params({

    })
  })
}


/**
 * @msg: 上传文件返回fileId
 */
export function addUploadFile(data, formData) {
  return http({
    url: http.baseUrl('file/addUploadFile'),
    method: 'POST',
    params: http.params(data),
    data: formData
  })
}

/**
 * @msg: 添加课件
 */
export function addCourse(data) {
  return http({
    url: http.baseUrl('zkolVideoData/saveOrUpdate'),
    method: 'POST',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 删除课件
 */
export function deleteList(ids) {
  return http({
    url: http.baseUrl('zkolVideoData/delete'),
    method: 'POST',
    params: http.params({
      ids
    }),
  })
}

/**
 * @msg: 预览查看详情
 */
export function getDetail({ id = '', courseWareId = '' }) {
  return http({
    url: http.baseUrl('zkolVideoData/getDetail'),
    method: 'POST',
    params: http.params({
      id,
      courseWareId
    }),
  })
}

/**
 * @msg: 启/禁用
 */
export function setStatus({ ids = '', status = '' }) {
  return http({
    url: http.baseUrl('zkolVideoData/setStatus'),
    method: 'POST',
    params: http.params({
      ids,
      status
    }),
  })
}


/**
 * @msg: 审核
 */
export function doCheck(data) {
  return http({
    url: http.baseUrl('zkolVideoData/doCheck'),
    method: 'POST',
    params: http.params(data),
  })
}

/**
 * @msg: 下载课件
 */
export function upload(id) {
  return http({
    url: http.baseUrl('zkolVideoData/upload'),
    method: 'POST',
    params: http.params({
      id
    }),
  })
}

/**
 * @msg: 上传后预览视频
 */
export function beforeSaveUpload(id) {
  return http({
    url: http.baseUrl('zkolVideoData/beforeSaveUpload'),
    method: 'POST',
    params: http.params({
      id
    }),
  })
}

/**
 * @msg: 上传后预览pdf
 */
export function reviewUploadPDF(id) {
  return http({
    url: http.baseUrl('zkolVideoData/upload'),
    method: 'POST',
    params: http.params({
      id
    }),
  })
}





// 知识清单api
/**
 * @msg: 获取知识清单列表
 */
export function knowledgeGetList({ page = '1', pageSize, knowledgeName = '', knowledgeDescription = '', courseWareId = '', orderBy = '' }) {
  return http({
    url: http.baseUrl('knowledge/getList'),
    method: 'get',
    params: http.params({
      page,
      pageSize,
      knowledgeName,
      knowledgeDescription,
      courseWareId,
      orderBy
    })
  })
}



/**
 * @msg: 添加/修改知识清单
 */
export function addKnowledge(data) {
  return http({
    url: http.baseUrl('knowledge/addKnowledge'),
    method: 'post',
    params: http.params(data),
    data: data
  })
}


/**
 * @msg: 通过uid获取用户
 */
export function getUserByUid(uid) {
  return http({
    url: http.baseUrl('elUser/getUserByUid'),
    method: 'get',
    params: http.params({
      uid
    })
  })
}

/**
 * @msg: 通过uid获取角色
 */
 export function getFindUserByUid(uid) {
  return http({
    url: http.baseUrl('elUser/findUserByUid'),
    method: 'get',
    params: http.params({
      uid
    })
  })
}

/**
 * @msg: 通过uid获取机构
 */
export function getSchoolByUid(uid) {
  return http({
    url: http.baseUrl('elSchool/getSchoolByUid'),
    method: 'get',
    params: http.params({
      uid
    })
  })
}


/**
 * @msg: 删除知识清单
 */
export function updateStatus(id) {
  return http({
    url: http.baseUrl('knowledge/updateStatus'),
    method: 'get',
    params: http.params({
      id
    })
  })
}

/**
 * @msg: 查看知识清单
 */
export function viewKnowledge(id) {
  return http({
    url: http.baseUrl('knowledge/viewKnowledge'),
    method: 'post',
    params: http.params({
      id
    })
  })
}

/**
 * @msg: 合并知识清单
 */
export function mergeKnowledge(newId, oldId) {
  return http({
    url: http.baseUrl('knowledge/mergeKnowledge'),
    method: 'get',
    params: http.params({
      newId,
      oldId
    })
  })
}


/**
 * @msg: 知识点导入
 */
export function importExcel(data) {
  return http({
    url: http.baseUrl('knowledge/importExcel'),
    method: 'post',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 省考试大纲知识点导入
 */
export function importZkolExaminationSyllabusExcel(data) {
  return http({
    url: http.baseUrl('knowledge/importZkolExaminationSyllabusExcel'),
    method: 'post',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 查看省考试大纲知识点
 */
export function getZkolExaminationSyllabusList(data) {
  return http({
    url: http.baseUrl('knowledge/getZkolExaminationSyllabusList'),
    method: 'get',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 删除省考试大纲知识点
 */
export function delZkolExaminationSyllabusList(data) {
  return http({
    url: http.baseUrl('knowledge/closeExaminationSyllabus'),
    method: 'post',
    params: http.params(data),
    data: data
  })
}


/**
 * @msg: 更新操作日志
 */
export function getListProcess(id) {
  return http({
    url: http.baseUrl('zkolVideoData/getListProcess'),
    method: 'post',
    params: http.params({
      id
    }),

  })
}


/**
 * @msg: 课件使用情况
 */
export function getListCites(id) {
  return http({
    url: http.baseUrl('zkolVideoData/getListCites'),
    method: 'post',
    params: http.params({
      id
    }),

  })
}

/**
 * @msg: 导入课件列表
 */
export function importExcel2(data) {
  return http({
    url: http.baseUrl('zkolVideoData/importExcel'),
    method: 'post',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 获取讲师列表
 */
export function getTeacher(data) {
  return http({
    url: http.baseUrl('elUser/getTeacher'),
    method: 'post',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 获取知识点对照表
 */
export function getKnowledgeComparisonTable(data) {
  return http({
    url: http.baseUrl('elZyVideoSection/getKnowledgeComparisonTable'),
    method: 'get',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 导入课件架构
 */
export function importExcelCourse(data) {
  return http({
    url: http.baseUrl('elZyVideoSection/importExcelCourse'),
    method: 'post',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 更新试题知识点
 */
export function importExamsQuest(data) {
  return http({
    url: http.baseUrl('elZyVideoSection/importExamsQuest'),
    method: 'post',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 获取开课列表批次
 */
export function getMaxBatch(data) {
  return http({
    url: http.baseUrl('zkolOpenCourseRecord/getMaxBatch'),
    method: 'get',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 获取开课列表
 */
export function getCourseRecordList(data) {
  return http({
    url: http.baseUrl('zkolOpenCourseRecord/getList'),
    method: 'get',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 获取开课列表-备份
 */
 export function getCourseRecordListCopy(data) {
  return http({
    url: http.baseUrl('zkolOpenCourseRecord/getList'),
    method: 'get',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 保存更新开课
 */
export function saveOrUpdateCourseRecord(data) {
  return http({
    url: http.baseUrl('zkolOpenCourseRecord/saveOrUpdate'),
    method: 'post',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 获取开课详情
 */
export function getCourseRecordDetail(data) {
  return http({
    url: http.baseUrl('zkolOpenCourseRecord/getDetail'),
    method: 'get',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 删除开课列表
 */
export function deleteCourseRecord(data) {
  return http({
    url: http.baseUrl('zkolOpenCourseRecord/delete'),
    method: 'post',
    params: http.params(data),
    data: data
  })
}

/**
 * @msg: 获取任课老师列表
 */
 export function getTeacherUserList(uid) {
  return http({
    url: http.baseUrl('zkolOpenCourseRecord/getTeacherUser'),
    method: 'POST',
    params: http.params({
      uid
    }),
  })
}

/**
 * @msg: 获取报名批次
 */
 export function getApplyBatchList() {
  return http({
    url: http.baseUrl('zkolOpenCourseRecord/getApplyBatch'),
    method: 'get',
  })
}

/**
 * @msg: 获取报名批次课程
 */
 export function getApplyBatchCourseList(params) {
  return http({
    url: http.baseUrl('zkolOpenCourseRecord/getApplyBatchList'),
    method: 'get',
    params: http.params(params),
  })
}

/**
 * @msg: 获取知识点对照表附件列表
 */
 export function getUploadFileList(params) {
  return http({
    url: http.baseUrl('file/getUploadFileList'),
    method: 'get',
    params: http.params(params),
  })
}

/**
 * @msg: 知识点对照表附件列表删除
 */
 export function delUploadFile(params) {
  return http({
    url: http.baseUrl('file/delUploadFile'),
    method: 'get',
    params: http.params(params),
  })
}

/**
 * @msg: 获取知识点对照表附件当前附件路径信息
 */
 export function getFileUrl(params) {
  return http({
    url: http.baseUrl('file/getFileUrl'),
    method: 'get',
    params: http.params(params),
  })
}

/**
 * @msg: 上传文件返回fileId
 */
 export function addVideoUploadFile1(data, formData) {
  return http({
    url: http.baseUrl('file/addVideoUploadFile'),
    method: 'POST',
    params: http.params(data),
    data: formData
  })
}
